import { useTranslation } from '@/lib/i18n/react';
import { useRetryChannelMessage, type ChannelMessage } from '../queries';

export function FailedMessageActions({channelId,message}:{channelId:string;message:ChannelMessage}) {
  const {t}=useTranslation('teamchat'),retry=useRetryChannelMessage();
  if(!message.failed||!message.id)return null;
  return <div role="status" className="mt-1 flex flex-wrap items-center gap-2 text-xs text-red-600">
    <span>{t(message.uncertain?'write.unconfirmed':'view.sendFailed')}</span>
    {!message.uncertain&&<button type="button" className="btn btn-secondary min-h-11" disabled={retry.isPending} onClick={()=>retry.retry(channelId,message)}>{t('retry')}</button>}
    <button type="button" className="btn btn-secondary min-h-11" onClick={()=>retry.discard(channelId,message.id!)}>{t('view.shared.inbox.proposal.dismiss')}</button>
  </div>;
}
